// extracted by mini-css-extract-plugin
module.exports = {"DialogCheckbox":"LogoutDialog_DialogCheckbox__OcbQu","LogoutDialog":"LogoutDialog_LogoutDialog__3pCV5"};